import React from 'react';

interface Props {
  color?: string;
  size?: number;
}

/**
 * ウォレット/残高アイコン（マイページ 現在の残高カード）
 * 元SVG: 求人詳細.svg cls-25 (円形ウォレット)
 * 元SVG offset (-68, -274) を M 座標に適用済み
 * viewBox: 0 0 24 15
 */
const WalletBalanceIcon: React.FC<Props> = ({ color = 'white', size = 24 }) => (
  <svg
    viewBox="0 0 24 15"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M0.96,0.3h20.62c.3,0,.55.27,.55.58v3.04h-6.19c-.33,0,-.6.14-.82.33-.19.22-.33.49-.33.79v4.82c0,.3.14,.6.33,.79h0c.22,.22.49,.33.82,.33h6.19v3.04c0,.33-.25,.58-.55,.58h-20.62c-.3,0,-.58-.25-.58-.58v-13.15c0-.3.27-.58.58-.58h0ZM15.94,4.49h7.09c.33,0,.58.25,.58.55v4.82c0,.3-.25,.58-.58,.58h-7.09c-.33,0,-.58-.27-.58-.58v-4.82c0-.3.25-.55.58-.55h0ZM18.66,5.92c.44,0,.82.16,1.1.44h0c.27.3,.44.68,.44,1.1,0,.44-.16.82-.44,1.1h0c-.27.27-.66.44-1.1.44-.41,0-.82-.16-1.1-.44h0c-.27-.27-.44-.66-.44-1.1,0-.41.16-.82.44-1.1s.66-.44,1.1-.44h0ZM3.04,3.02c-.3,0,-.55-.27-.55-.58s.25-.55.55-.55h16.02c.33,0,.58.25,.58.55s-.25.58-.58.58h-16.02Z"
    />
  </svg>
);

export default WalletBalanceIcon;
